var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09325 3.69198C7.35533 3.46734 7.74989 3.49769 7.97453 3.75977L12.9745 9.5931C13.1752 9.82716 13.1752 10.1725 12.9745 10.4066L7.97453 16.2399C7.74989 16.502 7.35533 16.5324 7.09325 16.3077C6.83117 16.0831 6.80082 15.6885 7.02546 15.4264L11.6768 9.99985L7.02546 4.57326C6.80082 4.31118 6.83117 3.91662 7.09325 3.69198Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.b68b8755d1628bbb115b8ec87e82919c.svg";
export { ForwardRef as ReactComponent };